import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b46a537"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification-dot"
}
const _hoisted_2 = { class: "notification-icon-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "notification-count"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/bell_icon.svg",
  alt: "notification",
  class: "notification-icon"
}, null, -1))

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'notificationHandler',
  props: {
    notificationCount: {}
  },
  setup(__props: any) {

const store = useStore();

const systemActions = computed(() => store.state.Notification.systemActions);

const planOrgDetail = computed(() => {
  const orgPlan = store.getters["Org/getPlanDetails"];
  return orgPlan && orgPlan.planId ? true : false;
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`notification tw-relative ${
      planOrgDetail.value ? '' : 'cursor-pointer-unset'
    }`)
  }, [
    (parseInt(systemActions.value) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      (parseInt(_ctx.notificationCount) > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(parseInt(_ctx.notificationCount) > 9 ? `9+` : _ctx.notificationCount), 1))
        : _createCommentVNode("", true),
      _hoisted_4
    ])
  ], 2))
}
}

})